import { useMemo } from 'react';
import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { BulkMessagingSVG } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { useBulkNavigator } from '../../../hooks/use-bulk-navigator';

type Props = {
  campaignType?: CampaignType;
};

// TODO: Test this out and make sure it looks good.
export const Welcome = ({ campaignType }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const navigateTo = useBulkNavigator(campaignType);

  const title = useMemo(() => {
    if (campaignType === CampaignType.EMAIL) {
      return t('Still sending emails one-at-a-time?');
    }
    if (campaignType === CampaignType.SMS) {
      return t('Still sending texts one-at-a-time?');
    }
    return t('Still sending messages one-at-a-time?');
  }, [campaignType, t]);

  const subTitle = useMemo(() => {
    if (campaignType === CampaignType.EMAIL) {
      return t('Get the word out quicker with Weave Email Marketing.');
    }
    if (campaignType === CampaignType.SMS) {
      return t('Get the word out quicker with Weave Bulk Texting.');
    }
    return t('Get the word out quicker with Weave Bulk Messaging.');
  }, [campaignType, t]);

  return (
    <div
      css={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        marginTop: theme.spacing(10),
      }}
    >
      <img
        src={BulkMessagingSVG}
        alt='bulk-messaging'
        css={{
          marginBottom: theme.spacing(5),
          maxWidth: '75%',
        }}
      />
      <Text
        weight='bold'
        css={{
          fontSize: theme.fontSize(24),
        }}
      >
        {title}
      </Text>
      <Text
        weight='bold'
        css={{
          color: theme.colors.primary80,
          fontSize: theme.fontSize(24),
          marginBottom: theme.spacing(1),
        }}
      >
        {subTitle}
      </Text>
      <Text
        css={{
          fontSize: theme.fontSize(20),
          marginBottom: theme.spacing(1),
        }}
      >
        {t('To use this service you must be subscribed.')}
      </Text>
      <Button
        onClick={() => {
          navigateTo.subscriptions();
        }}
        size='small'
      >
        {t('Begin Here')}
      </Button>
    </div>
  );
};
